export const convertToKebabCase = (text: string) => {
  return text.toLowerCase().replace(/\s|_/g, "-");
};

export function capitalizeFirstLetter(text: string) {
  return `${text.replace(text.charAt(0), text.charAt(0).toUpperCase())}`;
}
